export default function getPosition(el) {
  const coordinates = {
    left: 0,
    top: 0,
    height: el.scrollHeight,
    width: el.scrollWidth
  };

  while (el) {
    if (el.tagName === 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      const yScroll = el.scrollTop || document.documentElement.scrollTop;

      coordinates.left += (el.offsetLeft - xScroll + el.clientLeft);
      coordinates.top += (el.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      coordinates.left += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      coordinates.top += (el.offsetTop - el.scrollTop + el.clientTop);
    }

    el = el.offsetParent;
  }

  return coordinates;
}

global.getPosition = getPosition;



// WEBPACK FOOTER //
// ./shared/lib/getPosition.js